import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { CreateModalRHF } from '../../Shared/CreateModalRHF';
import { useCreateAccount } from '../../../../hooks';

const { NAME, API_KEY, SIGNING_SECRET } = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const TelnyxCreateModal = () => {
  const { createAccount } = useCreateAccount();
  return (
    <CreateModalRHF headerText="Connect Telnyx account" onSubmit={createAccount}>
      <ConnectedInputField name={NAME} labelText="Name" data-test="name-input" />
      <ConnectedInputField name={API_KEY} labelText="API key" data-test="apiKey-input" />
      <ConnectedInputField
        name={SIGNING_SECRET}
        labelText="Signing secret"
        data-test="signingSecret-input"
      />
    </CreateModalRHF>
  );
};
